import { createTheme } from "@mui/material/styles";

/**
 * One look for the MUI parts (buttons, dialogs, toasts, tables) that matches
 * the template colours and fonts used everywhere else (public/assets/css and
 * src/styles/app.css).
 */
const theme = createTheme({
  palette: {
    primary: { main: "#4154f1", dark: "#2f3fc7", contrastText: "#fff" },
    secondary: { main: "#6f42c1", contrastText: "#fff" },
    success: { main: "#198754", contrastText: "#fff" },
    warning: { main: "#d97706", contrastText: "#fff" },
    error: { main: "#dc3545" },
    info: { main: "#0d6efd" },
    text: { primary: "#2c384e" },
  },
  shape: { borderRadius: 6 },
  typography: {
    fontFamily: '"Open Sans", "Segoe UI", Roboto, Arial, sans-serif',
    button: { textTransform: "none", fontWeight: 600, letterSpacing: 0 },
  },
  components: {
    MuiButton: {
      defaultProps: { disableElevation: true },
      styleOverrides: { root: { paddingInline: 18, minHeight: 38 } },
    },
    MuiDialog: {
      styleOverrides: { paper: { borderRadius: 10 } },
    },
  },
});

export default theme;
